export const getPhoneNumberValue = (phone) => {
  const phoneNumberString = phone ? String(phone.split(" ").pop()) : "";
  return phoneNumberString.replace(/-/g, "");
};
